export default values => ({
  rfc: values.rfc ?? '',
  facebook: values.facebook ?? '',
  instagram: values.instagram ?? '',
  webSite: values.webSite ?? ''
});
